import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { loadActiveStudentsDailyAsync, selectActiveStudentsDaily } from '../dashboardSlice';
import { StatCard } from './StatCard';

const HISTORY_DAYS = 14;

export const ActiveStudentsCard = () => {
    const dispatch = useDispatch();
    const routerHistory = useHistory();
    const { data, status } = useSelector(selectActiveStudentsDaily);

    useEffect(() => {
        dispatch(loadActiveStudentsDailyAsync(HISTORY_DAYS));
    }, [dispatch]);

    const { today, history } = useMemo(() => {
        if (!Array.isArray(data) || !data.length) return { today: 0, history: [] };
        return {
            today: data[data.length - 1]?.count ?? 0,
            history: data.map(d => d.count),
        };
    }, [data]);

    return (
        <StatCard
            label="Usuários ativos"
            secondary="Com assinatura válida"
            icon="pi-verified"
            color="var(--purple-500)"
            value={today}
            loading={status === 'idle'}
            history={history}
            onClick={() => routerHistory.push('/users', { preset: 'activeStudents', presetLabel: 'Alunos ativos' })}
        />
    );
};
